import { Box, Title } from 'vopay';
import ChangePasswordForm from './ChangePasswordForm';
import { useTranslation } from 'react-i18next';
import { JSX } from 'react';
import { useHistory } from 'react-router-dom';
import { UtilButton } from 'UI';

const UserProfile = (): JSX.Element => {
  const { t: tGlobal } = useTranslation('translations', { keyPrefix: 'Global' });
  const { t } = useTranslation('translations', { keyPrefix: 'Users.UsersList.ChangePassword' });
  const history = useHistory();

  return (
    <Box jc="center">
      <Box flx="col" gapSize="25px" jc="center" maxwidth="1121px" boxWidth="100%">
        <Box flx="col" gapSize="13px">
          <UtilButton
            iconLeft="chevron_left"
            size="large"
            onClick={() => {
              history.goBack();
            }}
          >
            {tGlobal('Buttons.back')}
          </UtilButton>
          <Title title={t('title')} />
        </Box>
        <ChangePasswordForm />
      </Box>
    </Box>
  );
};

export default UserProfile;
